import React, { useContext } from "react";
import Footer from "../components/Footer";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useState, useEffect } from "react";
import Global, { fetchProducts, getProductsPriceRange } from "../util/Global";
import { LoaderComponent } from "../util/Loader";
import ProductsFilter from "../components/Products/ProductsComponents";
import { AlertContext } from "../util/Alerter";
import ProductsComponent from "../components/Products/ProductsComponent";
import { CurrencyContext, DeliveryCountryContext } from "../components/Utils";



const PRODUCT_URL = Global.backend + "/index.php/produit/showall";
const ENTREPRISE_URL = Global.backend + "/index.php/entreprise/list";




const Marketplace = ({ promotionOnly }) => {
  const { t } = useTranslation();
  const { showAlert } = useContext(AlertContext)
  const { countries } = useContext(DeliveryCountryContext)
  const [entreprises, setEntreprises] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [priceRange, setpriceRange] = useState([0, 0]);
  const [productList, setProductList] = useState([]);
  const [isLoading, setisLoading] = useState(true)
  const { currency, getCurrencyPrice } = useContext(CurrencyContext)
  const { deliveryCountry } = useContext(DeliveryCountryContext)



  useEffect(() => {
    setisLoading(true)

    axios.all([axios.get(ENTREPRISE_URL), axios.post(PRODUCT_URL, { deliveryCountry })])
      .then(axios.spread((entrepriseResponse, productsResponse) => {
        setEntreprises(entrepriseResponse.data)

        const products = productsResponse.data.filter(product => product.visibilite)

        if (!products.length) {
          return
        }

        const productList = fetchProducts(productsResponse, promotionOnly)


        setProductList(productList)
        setpriceRange(getProductsPriceRange(productList, currency, getCurrencyPrice))
      })).catch((err) => {
        console.log(err);

        showAlert("error", t("request.errorFetchProductDetails"))
      })
      .finally(() => {
        setisLoading(false)
      })
  }, []);



  useEffect(() => {
    if (isLoading) {
      return
    }

    setpriceRange(getProductsPriceRange(productList, currency, getCurrencyPrice))
  }, [currency, isLoading])




  return (
    <div>

      <LoaderComponent isLoading={isLoading}>
        <main
          className="my-main ttm-bgcolor-grey"
          style={{
            minHeight: "calc(100vh + 700px)",
          }}
        >
          <div className="container-fluid bg-trasparent my-4 p-3">
            <div className="row">
              <ProductsFilter title={t(promotionOnly ? "navigation3.1" : "navigation2.1")} productList={productList} setFilteredList={setFilteredList} defaultPriceRange={priceRange} entreprises={entreprises} pays={countries} />

              <div className="col-md-9">
                <div className="container-fluid">
                  <ProductsComponent itemsPerPage={8} items={filteredList} />
                </div>
              </div>
            </div>
          </div>


        </main>
      </LoaderComponent>
      <Footer />
    </div>
  );
};

export default Marketplace;
